// Ported from @Corim/architecture-frontend. Subscribes a component to an rx
// store (or the global Dispatch state when no store is given) and re-renders
// on every emission.
import _ from 'lodash'
import React from 'react'

import Dispatch from './Dispatch'

export default class RxBaseComponent extends React.Component {
  componentWillMount() {
    const store = _.isNil(this.props.store) ? Dispatch.getState() : this.props.store
    this.Store = store.subscribe(e => {
      this.setState(e)
    })
  }

  componentWillUnmount() {
    this.Store.unsubscribe()
  }

  render() {
    const { Component, store, ...withoutComponent } = this.props
    const combinedProps = _.merge({}, { Dispatch }, withoutComponent, this.state)

    const ComponentToRender = Component
    return <ComponentToRender {...combinedProps} />
  }
}
